"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NextSongCommand = void 0;
const regex_1 = require("../../../common/regex");
const Course_1 = require("../../course/Course");
const Difficulty_1 = require("../../course/lib/Difficulty");
const Song_1 = require("../../song/Song");
const Command_1 = require("../Command");
const CommandType_1 = require("../lib/CommandType");
/**
 * Changes song when `COURSE`: is set to "Dan" or "6". Value is a comma
 * separated array, with these values, all of which are required:
 * - Song title
 * - Song subtitle
 * - Song genre
 * - Audio filename
 * - ScoreInit
 * - ScoreDiff
 * Comma character in the value can be escaped with a backslash character (`\`).
 *
 * **Example**:
 *
 * ```
 * #NEXTSONG GO!GO!明るい社会,うるまでるび,バラエティ,GO!GO!明るい社会.ogg,560,160
 * ```
 */
class NextSongCommand extends Command_1.Command {
    constructor(song) {
        super(CommandType_1.CommandType.BMScroll);
        this.song = song;
    }
    static parse(args) {
        if (args.length === 0) {
            return undefined;
        }
        const components = args[0]
            .replace(regex_1.ESCAPED_COMMA_REGEX, '|')
            .split(',')
            .map((c) => c.replace(regex_1.PIPE_REGEX, ','));
        if (components.length < 6) {
            return undefined;
        }
        const song = new Song_1.Song();
        song.title = components[0];
        song.subtitle = components[1];
        song.genre = components[2];
        song.wave = components[3];
        const course = new Course_1.Course();
        course.difficulty = Difficulty_1.Difficulty.Dan;
        course.activeCourse.scoreInit = parseInt(components[4], 10);
        course.activeCourse.scoreDiff = parseInt(components[5], 10);
        song.addCourse(course);
        return new NextSongCommand(song);
    }
    toString() {
        const songData = [
            this.song.title,
            this.song.subtitle,
            this.song.genre,
            this.song.wave,
            this.song.courses[0].activeCourse.scoreInit,
            this.song.courses[0].activeCourse.scoreDiff,
        ].join(',');
        return `${super.toString()} ${songData}`;
    }
}
exports.NextSongCommand = NextSongCommand;
